import {  useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CboFPago from "./CboFPago.js";

const ModDetPago = ({ isOpen, onClose, fecPago, setFecPago, fPagoDet, setFPagoDet, inpoValidar }) => {
const [message, setMessage] = useState("")  
const [impoTotal, setImpoTotal] = useState(0);

  

const handlePagarAca= () =>
{
  // validar si el total de los ítems de pago suma el ImpoValidar (que es el importe que se cargó para pagar)
  let valid = true;
  valid = Math.abs(impoTotal - inpoValidar) < 1 ;
  if (valid)
  {
    onClose(1);
  }
  
  else
    {
   setMessage("No coincide el monto");
    }

}

const handleCancelar = () =>
{
  onClose(0);

}

const handleAdd = () =>
{
   console.log("Add line F Pago");
   let nvaElfPagoDet = {"fpago": 0, "Comprob" : '', "Descrip" : '', "Importe" : 0 };
   const nvafPagoDet = [...fPagoDet];
   nvafPagoDet.push(nvaElfPagoDet)
   setFPagoDet(nvafPagoDet);
}


const handleFormPagoChange = ( event, inx) =>
{

        const nvafPagoDet = fPagoDet.map((unElem, index) => {
console.log(index, "-", inx)
        if (index === inx) {
          

          return { ...unElem, fpago: event.target.value };
          }

        else
        {
          return { ...unElem }
        };
    })
    

 setFPagoDet(nvafPagoDet);

}

const handleDescripChange = (textvalue, inx) =>
{

        const nvafPagoDet = fPagoDet.map((unElem, index) => {

        if (index === inx) {
          

          return { ...unElem, Descrip: textvalue };
          }

        else
        {
          return { ...unElem }
        };
    })
    

 setFPagoDet(nvafPagoDet);

}
const handleComprobChange = ( textvalue, inx) =>
{

        const nvafPagoDet = fPagoDet.map((unElem, index) => {

        if (index === inx) {
          

          return { ...unElem, Comprob: textvalue };
          }

        else
        {
          return { ...unElem }
        };
    })
    

 setFPagoDet(nvafPagoDet);

}

const handleImpoChange = ( textvalue, inx) =>
{
    let total = 0;
    setMessage("");
    const nvafPagoDet = fPagoDet.map((unElem, index) => {
      if (index === inx) 
      {
        
        total = total + parseFloat(textvalue);
        return { ...unElem, Importe: textvalue };
      }
      else
      {
        total = total + parseFloat(unElem.Importe);
        return { ...unElem }
      };
    })
    
 setImpoTotal(total);
 setFPagoDet(nvafPagoDet);

}



  if (!isOpen) return null; // No renderiza nada si está cerrado

  return (
    
<Modal
      show={isOpen} // Usa la prop que viene de App.js
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Forma de Pago</Modal.Title>
      </Modal.Header>

      <Modal.Body>

         <div className= "col-lg-offset-0 col-lg-2 col-xs-3 col-sm-2">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Fecha de Pago</label>
              <input type="date" className="form-control" id="exampleInputEmail1" placeholder="" onChange={e => {setFecPago(e.target.value)}}  value={fecPago} />
            </div>
          </div>  
 
 <div className="col-lg-offset-0 col-12">
              <table className=  "table table-striped table-info table-hover m3">

                  <thead>
                    <tr className="row" >
                      <th className="col-2" >F. Pago</th>
                      <th className="col-3" >Comprob</th>
                      <th className="col-4" >Descrip</th>
                      <th className="col-2" >Importe</th>
                      <th className="col-1" >Agregar</th>
                    </tr>
                  </thead>
                  <tbody>
                     

          

{
     fPagoDet.map (( unolista, index ) => (
      <>
       <tr key={index+'_rowfpago'}  className="row">
              
                 <td key={index+'_fpago'} className="col-2">
                <CboFPago
                  
                  selectedValue={unolista.fpago}
                  onChange={ (e) => handleFormPagoChange(e, index)  }
                  disabled={false}
                
                />
              </td>
               <td key={index+'_comprob'} className="col-3">
                   <input key={index+'_txtcomprob'} type="text" className="form-control" id={index+'comprobd'} placeholder="" value={unolista.Comprob} onChange={e => {handleComprobChange(e.target.value, index)}}  disabled={false}/>
                </td> 
               <td key={index+'_descrip'} className="col-4">
                   <input key={index+'_txtdescrip'} type="text" className="form-control" id={index+'descripd'} placeholder="" value={unolista.Descrip} onChange={e => {handleDescripChange(e.target.value, index)}} disabled={false}/>
                </td>       
                <td key={index+'_importe'} className="col-2">
                    <input key={index+'_txtimporte'}  type="text" className="form-control" id={index+'imported'} placeholder="" value={unolista.Importe} onChange={e => {handleImpoChange(e.target.value, index)}} disabled={false}/>
                </td>      

                <td key={index+'_add'} className="col-1">
                   <button key={index+'_button'} type="button" className="btn btn-info"  id="clear" onClick={handleAdd}  ><i className="bi bi-plus"></i></button>      
                 </td>                 
        </tr>
      </>
     )
    )
   
  }
                  </tbody>
                </table>
          </div>
  {message && <p className="text-danger mt-2">{message}</p>}
</Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancelar}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handlePagarAca}>
          Pagar
        </Button>
      </Modal.Footer>
    </Modal>

  );
};

export default ModDetPago;